<template>
  <v-app>
    <NavBar  />   
    <v-main> 
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar';

export default {
  name: 'App',

  components: {
    NavBar
  },

  data: () => ({
  }),
};
</script>

<style>
.v-application {
  font-family: Roboto, "Segoe UI", Arial, sans-serif;
}
</style>
